import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App" }
const _hoisted_2 = { class: "kefu" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("供应大厅")
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("发布")
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("求购大厅")
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("我的")
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "发布越多商机越多", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("发布供应")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "发布供应", -1)
const _hoisted_16 = { class: "btns" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "发处理苗木", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "发布单品采购", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "发布工程采购", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")!
  const _component_van_tabbar = _resolveComponent("van-tabbar")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "routerWarpper",
      style: _normalizeStyle({paddingBottom:$setup.height})
    }, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_KeepAlive, null, [
            (_ctx.$route.meta.keepAlive)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                  key: `keep-${_ctx.$route.name}`
                }))
              : _createCommentVNode("", true)
          ], 1024)),
          (!_ctx.$route.meta.keepAlive)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                key: `noKeep-${new Date().getTime()}`
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 4),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(_component_VanImage, {
        src: "https://mdd-static.oss-cn-hangzhou.aliyuncs.com/app/home/kefu_logo_home.png",
        width: "72",
        height: "76",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toKefu()))
      })
    ], 512), [
      [_vShow, $setup.isShowKefu]
    ]),
    _withDirectives(_createVNode(_component_van_tabbar, {
      class: "tabbar",
      ref: "tabbar",
      modelValue: $setup.active,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.active) = $event)),
      fixed: "",
      "active-color": "#FEC64B",
      onChange: $setup.tabChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tabbar_item, {
          icon: "home-o",
          name: "Home"
        }, {
          icon: _withCtx((props) => [
            _createElementVNode("img", {
              src: props.active ? $setup.tabbarIcons.home.active : $setup.tabbarIcons.home.inactive,
              width: "36",
              height: "36"
            }, null, 8, _hoisted_4)
          ]),
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_van_tabbar_item, {
          icon: "home-o",
          name: "SupplyList"
        }, {
          icon: _withCtx((props) => [
            _createElementVNode("img", {
              src: props.active ? $setup.tabbarIcons.supply.active : $setup.tabbarIcons.supply.inactive,
              width: "36",
              height: "36"
            }, null, 8, _hoisted_6)
          ]),
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_van_tabbar_item, {
          icon: "home-o",
          name: "Release",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.isShowRelease = !$setup.isShowRelease))
        }, {
          icon: _withCtx((props) => [
            _createElementVNode("img", {
              src: props.active ? $setup.tabbarIcons.release.active : $setup.tabbarIcons.release.inactive,
              width: "36",
              height: "36"
            }, null, 8, _hoisted_8)
          ]),
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_van_tabbar_item, {
          icon: "home-o",
          name: "WantToBuy"
        }, {
          icon: _withCtx((props) => [
            _createElementVNode("img", {
              src: props.active ? $setup.tabbarIcons.purchase.active : $setup.tabbarIcons.purchase.inactive,
              width: "36",
              height: "36"
            }, null, 8, _hoisted_10)
          ]),
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_van_tabbar_item, {
          icon: "home-o",
          name: "My"
        }, {
          icon: _withCtx((props) => [
            _createElementVNode("img", {
              src: props.active ? $setup.tabbarIcons.profile.active : $setup.tabbarIcons.profile.inactive,
              width: "36",
              height: "36"
            }, null, 8, _hoisted_12)
          ]),
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]), [
      [_vShow, $setup.isShowTab]
    ]),
    _createVNode(_component_VanPopup, {
      class: "releasePopup",
      show: $setup.isShowRelease,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => (($setup.isShowRelease) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _hoisted_13,
        _createElementVNode("div", {
          class: "releaseSupply",
          onClick: _cache[3] || (_cache[3] = ($event: any) => {$setup.isShowRelease=false;$setup.router.push("ReleaseSupply")})
        }, [
          _hoisted_14,
          _createVNode(_component_VanImage, {
            src: require("@/assets/img/releaseSupply.png"),
            height: "24",
            width: "64"
          }, null, 8, ["src"]),
          _hoisted_15
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", {
            class: "releaseOther",
            onClick: _cache[4] || (_cache[4] = ($event: any) => {$setup.isShowRelease=false;$setup.router.push("ReleaseProcessing")})
          }, [
            _createVNode(_component_VanImage, {
              src: require("@/assets/img/publish_logo_bargain.png"),
              height: "20",
              width: "20"
            }, null, 8, ["src"]),
            _hoisted_17
          ]),
          _createElementVNode("div", {
            class: "releaseOther",
            onClick: _cache[6] || (_cache[6] = ($event: any) => {$setup.isShowRelease=false;_ctx.$router.push("ReleaseWantToBuy")})
          }, [
            _createVNode(_component_VanImage, {
              src: require("@/assets/img/ready_left_top.png"),
              height: "20",
              width: "20",
              onClick: _cache[5] || (_cache[5] = ($event: any) => {$setup.isShowRelease=false;$setup.router.push("ReleaseWantToBuy")})
            }, null, 8, ["src"]),
            _hoisted_18
          ]),
          _createElementVNode("div", {
            class: "releaseOther",
            onClick: _cache[7] || (_cache[7] = ($event: any) => {$setup.isShowRelease=false;$setup.router.push("ReleaseEngineering")})
          }, [
            _createVNode(_component_VanImage, {
              src: require("@/assets/img/ready_right_top.png"),
              height: "20",
              width: "20"
            }, null, 8, ["src"]),
            _hoisted_19
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}